export const normalizarDocumento = (value: string): string => {
    return (value || '')
        .replace(/[^A-Za-z0-9]/g, '')
        .toUpperCase();
}

export const removerMascaraDocumento = normalizarDocumento;

export const isCpf = (value: string): boolean => {
    const normalizado = normalizarDocumento(value);
    return normalizado.length === 11 && /^\d{11}$/.test(normalizado);
}

export const isCnpj = (value: string): boolean => {
    return normalizarDocumento(value).length === 14;
}

export const isCnpjAlfaNumerico = (value: string): boolean => {
    const normalizado = normalizarDocumento(value);
    return normalizado.length === 14 && /^\d{14}$/.test(normalizado);
}

export const formatarCPFCNPJ = (value: string) => {
    return maskCnpjCpf(value)
}

export function maskCpf(value: string) {
    let valor = value.replace(/\D/g, '').substring(0, 11);

    valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
    valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
    valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    return valor;
}

export function maskCnpj(value: string) {
    const valor = normalizarDocumento(value).substring(0, 14);

    if (valor.length <= 2) {
        return valor;
    }

    let resultado = valor.substring(0, 2);

    if (valor.length > 2) {
        resultado += `.${valor.substring(2, Math.min(5, valor.length))}`;
    }
    if (valor.length > 5) {
        resultado += `.${valor.substring(5, Math.min(8, valor.length))}`;
    }
    if (valor.length > 8) {
        resultado += `/${valor.substring(8, Math.min(12, valor.length))}`;
    }
    if (valor.length > 12) {
        resultado += `-${valor.substring(12, 14)}`;
    }

    return resultado;
}

const documentoTemLetra = (valor: string) => /[A-Z]/.test(valor);

const deveUsarMascaraCnpj = (valor: string) =>
    documentoTemLetra(valor) || valor.length > 11;

export function maskCnpjCpf(value: string) {
    const valor = normalizarDocumento(value);
    if (deveUsarMascaraCnpj(valor)) {
        return maskCnpj(value);
    }
    return maskCpf(value);
}

export function maskCnpjCpfGeral(value: string) {
    const valor = normalizarDocumento(value);

    if (valor.length === 14) {
        return maskCnpj(value);
    }
    if (valor.length === 11 && !documentoTemLetra(valor)) {
        return maskCpf(value);
    }
    if (deveUsarMascaraCnpj(valor)) {
        return maskCnpj(value);
    }
    if (valor.length > 0) {
        return maskCpf(value);
    }
    return valor;
}